export const toBooleanFromStr = (v: string) => {
  if (!v) return false
  const str = v.toString()
  return str.toLowerCase() === 'true'
}
